<ng-container
  *puLet="dropdown()?.isDropdownOpened$ | async as isDropdownOpened">
  @if (isDropdownOpened) {
    <div class="overlay-under-side-and-nav"></div>
  }

  <button
    class="menu-button"
    type="button"
    puButton
    size="s"
    uiType="quaternary"
    [puDropdownTriggerFor]="menu"
    alignX="end"
    [inheritWidth]="false">
    <pu-icon
      [iconName]="isDropdownOpened ? 'cross' : 'menu'"
      [size]="isDropdownOpened ? 16 : 32" />
  </button>

  <pu-dropdown #menu [closeOnClick]="false">
    <pp-menu-dialog (navItemClicked)="closeMenu($event)" />
  </pu-dropdown>

  <!-- <div class="top-border"></div> -->
</ng-container>
